export default __webpack_public_path__ + "static/media/comment_icon.04c9b1ae.svg";